import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, OnDestroy, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { BackofficeService } from '../models/backoffice.service';
import { ApplicationRouteURL } from '../../shared/config';

declare var ChangeBranding: any;
@Component({
  selector: 'wego-backoffice',
  template: require('../views/backoffice.component.html'),
  providers: [BackofficeService]
})
export class BackofficeComponent implements OnInit, OnDestroy {
  private roleList: string[] = [];
  private isLoading: boolean;
  private errorMessage: string;
  public firstName: string;
  public lastName: string;
  public currentRole: string;
  public isDiverLicenceRequire: boolean;
  public isValidateDriverIBAN: boolean;
  private isTwoFaRequired: boolean;

  constructor(
    private backOfficeService: BackofficeService,
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.GetUserSettingByPersonHashID();
  }

  public GetUserSettingByPersonHashID() {
    this.backOfficeService.GetUserSettingByPersonHashID().subscribe(
      (res: any) => {
        if (res.data) {
          let userSetting = {
            firstName: res.data.firstName,
            lastName: res.data.lastName,
            middleName: res.data.middleName,
            highestEntityLevelRole: res.data.highestEntityLevelRole,
            instanceLanguage: res.data.instanceLanguage
          };

          this.isTwoFaRequired = res.data.isTwoFaRequired;

          localStorage.setItem('user_setting', JSON.stringify(userSetting));
          localStorage.setItem('language', res.data.language);
          localStorage.setItem('highest_role_level', res.data.highestRoleLevel);
          localStorage.setItem('home_URL', res.data.adminHomeURL);
          localStorage.setItem('TwoFa_method', res.data.selectedTwoFa);

          localStorage.setItem('computerId', res.data.userComputerId);


          this.roleList = res.data.role;
          this.isDiverLicenceRequire =
            res.data.validateDriverLicence == 'REQUIRED' ? true : false;
          this.isValidateDriverIBAN = res.data.validateDriverIBAN;
          this.errorMessage = res.error;
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => {
        if (this.roleList) {
          if (this.roleList.length == 1) {
            this.NavigateTo(this.roleList[0]);
          }
        } else {
          this.router.navigate(['/NotFound']);
        }
      }
    );
  }

  public CheckAccountActivationTermsConditionStatus() {
    this.isLoading = true;
    this.authService.CheckAccountActivationTermsConditionStatus().subscribe(
      res => {
        const isAccepted: boolean = res.data.accepted;
        if (!isAccepted) {
          let urlTermsAndConditions = ApplicationRouteURL.URL_TERMS_AND_CONDITION_POPUP;
          this.router.navigate([urlTermsAndConditions]);
        } else {
          this.CheckAccountActivationPrivacyStatementStatus();
        }
        this.isLoading = false;
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public CheckAccountActivationPrivacyStatementStatus() {
    this.isLoading = true;
    this.authService.CheckAccountActivationPrivacyStatus().subscribe(
      res => {
        const isAccepted: boolean = res.data.accepted;
        if (!isAccepted) {
          let urlPrivacyStatement = ApplicationRouteURL.URL_PRIVACY_STATEMENT_POPUP;
          this.router.navigate([urlPrivacyStatement]);
        } else {
          this.HandleDriverNavigation();
        }
        this.isLoading = false;
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public NavigateTo(role: string) {
    localStorage.setItem('current_role', role);

    ChangeBranding();

    if (role.toUpperCase() == 'WEGOADMIN') {

      if (this.isTwoFaRequired) {
        this.router.navigate([ApplicationRouteURL.URL_TWO_FA_SELECTION]);
      } else {
        this.router.navigate(['/wegoadmin']);
      }
    } else if (role.toUpperCase() == 'ADMIN') {
      if (this.isTwoFaRequired) {
        this.router.navigate([ApplicationRouteURL.URL_TWO_FA_SELECTION]);
      } else {
        this.router.navigate(['/admin']);
      }
    } else if (role.toUpperCase() == 'DRIVER') {
      window.location.href = 'https://driver-portal.wego.app/login';
    } else {
      this.router.navigate(['/underconstruction']);
      localStorage.removeItem('current_role');
    }
  }
  public HandleDriverNavigation() {
    if (this.isDiverLicenceRequire) {
      localStorage.removeItem('current_role');
      this.router.navigate(['/validatedriverlicence/driverlicencedetail']);
    } else if (this.isValidateDriverIBAN) {
      this.router.navigate([
        '/driver/profile',
        {
          personId: localStorage.getItem('personMasterHashId'),
          IBANNumberMessage: true
        }
      ]);
    } else {
      this.router.navigate(['/driver']);
    }
  }
  ngOnDestroy() {
    console.log('ngOnDestroy');
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/backoffice/components/backoffice.component.ts